/** The three ways a pivot field is filtered — a field holds one at a time. */
export enum PivotFilterKindEnum {
  Selection = 'Selection',
  Condition = 'Condition',
  Value = 'Value',
}
